export const ISSUES_FOR_CROSSCUTTING_REQUEST = "ISSUES_FOR_CROSSCUTTING_REQUEST";
export const ISSUES_FOR_CROSSCUTTING_SUCCESS = "ISSUES_FOR_CROSSCUTTING_SUCCESS";
export const ISSUES_FOR_CROSSCUTTING_FAILED = "ISSUES_FOR_CROSSCUTTING_FAILED";
